import { render, staticRenderFns } from "./ContentImpressum.vue?vue&type=template&id=002affd9&scoped=true&"
import script from "./ContentImpressum.vue?vue&type=script&lang=js&"
export * from "./ContentImpressum.vue?vue&type=script&lang=js&"
import style0 from "./ContentImpressum.vue?vue&type=style&index=0&id=002affd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002affd9",
  null
  
)

export default component.exports